import React from 'react';

import {Navigate} from 'react-router-dom';

import {ActivityIndicator} from 'components/ActivityIndicator';

import {useAuth} from 'hooks/useAuth';

import {useAccount} from 'hooks/useAccount';

import {useRedirectUrl} from 'hooks/useRedirectUrl';

import {useFirstApplication} from 'hooks/useFirstApplication';

export const IndexPage = () => {
    const account = useAccount();

    // if (typeof account === 'undefined' || account === null) {
    //     return <Navigate to="/404" />;
    // }

    const { user, profile, session } = useAuth({ account });

    const application = useFirstApplication();

    if (typeof application === 'undefined' || application === null) {
        return <ActivityIndicator label="Loading application... Please wait" />;
    }

    if (typeof account === 'undefined' || account === null) {
        return <ActivityIndicator label="Loading account... Please wait" />;
    }

    if (
        typeof session === 'undefined' ||
        session === null ||
        !session.isValid()
    ) {
        return <ActivityIndicator label="Loading session... Please wait" />;
        // return <Navigate to={`/credentials/${account.id}`} />;
    }

    if (typeof profile === 'undefined' || profile === null) {
        return <ActivityIndicator label="Loading Profile... Please wait" />;
    }

    // if (account.username !== user.username) {
    //     return <Navigate to={`/credentials/${account.id}`} />;
    // }
    if (
        account.emailAddress.toLowerCase() !==
        user.attributes.email.toLowerCase()
    ) {
        return <Navigate to={`/credentials/${account.id}`} />;
    }

    if (typeof profile !== 'undefined' && profile !== null) {
        if (
            typeof profile.tc === 'undefined' ||
            profile.tc.accepted === false
        ) {
            return (
                <Navigate to={`/user-agreements/acceptance/${account.id}`} />
            );
        }
    }

    const redirectUrl = useRedirectUrl({ application, session });
    console.debug("redirect url", redirectUrl)
    window.location.assign(redirectUrl);
    return null;
};
